export default __webpack_public_path__ + "static/media/Earrings.e9be49f3.jpg";